export const UserPipe = (user: string) => {
    if (user !== undefined) {
        const username =  user.split('@');
    
        return username[0];
      }
}